<template>
  <div class="flex h-screen flex-col overflow-y-hidden bg-white">
    <app-header class="flex justify-between px-5 overflow-visible w-1/3">
      <bot-selector :default-bot-id="botId" @change="changeBot" class="w-1/3 min-w-64" />
    </app-header>
    <div class="h-full">
      <div class="flex flex-col lg:flex-row w-full h-full">
        <shadowed-wrapper class="p-5 w-full lg:w-1/3 bg-background">
          <div v-html="emailPreview"
               title="preview"
               class="h-full block border border-solid rounded shadow-sm placeholder-gray bg-white font-sans text-gray-dark text-xl p-5"
               :class="{ 'border-soft': isDisabled }"
          />
        </shadowed-wrapper>

        <shadowed-wrapper class="h-full p-5 w-full lg:w-2/3">
          <t-textarea v-model="text"
                      rows="30"
                      autofocus
                      :disabled="isDisabled"
          />

          <div class="flex justify-end mt-5 gap-2">
            <base-button id="reset-to-last"
                         :variant="isDisabled ? 'transparent-disabled' : 'bordered'"
                         class="text-center w-1/5"
                         :disabled="isLoading || isDisabled"
                         @click="loadEmailTemplate"
            >
              Reset
            </base-button>
            <base-button id="save"
                         :variant="isDisabled ? 'primary-disabled' : 'primary'"
                         class="text-center w-1/5 justify-center"
                         :disabled="isLoading || isDisabled"
                         @click="saveEmailTemplate"
            >
              Save
            </base-button>
          </div>
        </shadowed-wrapper>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader.vue'
import BaseSelect from '@/components/base-components/BaseSelect.vue'
import BotSelector from '@/components/common/BotSelector.vue'
import ShadowedWrapper from '@/components/base-components/ShadowedWrapper.vue'
import botService from '@/services/amio/bot.service'
import emailConfigService from '@/services/amio/email-config.service'
import toaster from '@/utils/toaster'
import { BOT_TYPES } from '@/utils/bot.constants'
import variableRefsUtils from '@/utils/variable-refs.utils'
import variablesModule from '@/store/modules/variables.module'

export default {
  name: 'EmailTemplate',

  components: { ShadowedWrapper, BaseSelect, BotSelector, AppHeader },

  data() {
    return {
      text: '',
      isLoading: false,
      isDisabled: false
    }
  },

  mounted() {
    this.init()
  },

  computed: {
    botId() {
      return this.$route.params.botId
    },

    emailPreview() {
      return variableRefsUtils.substituteVariableRefs(this.text)
    }
  },

  methods: {
    async init() {
      const botType = await this.getBotType()
      if (botType !== BOT_TYPES.EMAIL) {
        toaster.error('This bot is not email bot')
        this.isDisabled = true
        return
      }

      await variablesModule.fetchVariables()
      await this.loadEmailTemplate()
    },

    async loadEmailTemplate() {
      if (this.isDisabled) return

      this.isLoading = true
      try {
        const { emailTemplate } = await emailConfigService.get(this.botId)
        this.text = emailTemplate
      } catch (err) {
        toaster.error(err)
      } finally {
        this.isLoading = false
      }
    },

    async saveEmailTemplate() {
      if (this.isDisabled) return

      this.isLoading = true
      try {
        await emailConfigService.update(this.botId, this.text)
        toaster.success('saved!')
      } catch (err) {
        toaster.error(err)
      } finally {
        this.isLoading = false
      }
    },

    async getBotType() {
      try {
        const { type } = await botService.getBot(this.botId)
        return type
      } catch (err) {
        toaster.error(err)
      }
    },

    changeBot(botId) {
      if (botId === this.botId) return

      this.$router.replace({ params: { botId } })
      this.text = ''
      this.isDisabled = false
      this.init()
    }
  }
}
</script>
